import { Axis, ResponseMessages } from "components/Constants"
import axios from "axios";
import { signOut } from "store/LoginState";
import store from "store";

/*
Get the list of tracking
*/
async function getTrackingListByAxisId(axisId) {
    try {
        let requestHeaders = createHeaders()

        console.log(`${Axis.GetEndPoint}/${axisId}/tracking`);
        let response = await axios({
            method: "get",
            url: `${Axis.GetEndPoint}/${axisId}/tracking`,
            headers: requestHeaders
        }).catch(error => {
            if (error.response) {
                if (error.response.status === 401) {
                    if(error.response.data.message === ResponseMessages.INVALID_TOKEN){
                        store().store.dispatch(signOut())
                    } else {
                        return error.response
                    }
                } else if (error.response.data) {
                    return error.response
                } else {
                    // Throw error if it's not a success response
                    throw new Error(`getTrackingListByAxisId returned a status code ${error.response.status}`)
                }
            }
        });

        if (response) {
            // If it's a success response
            if (response.status === 200) {
                return { success: true, data: response.data }
            } else {
                return { success: false, message: response.data.message }
            }
        } else {
            return { success: false, message: "Algo ocurrió mal, intentélo nuevamente" }
        }
    } catch (error) {
        console.error(error)
        return { success: false, message: "Algo ocurrió mal, intentélo nuevamente" }
    }
}


/*
Get the list of tracking
*/
async function getTrackingListByAxisIdP(axisId) {
    try {
        let requestHeaders = createHeaders()

        let response = await axios({
            method: "get",
            url: `${Axis.GetEndPoint}/${axisId}/trackingP`,
            headers: requestHeaders
        }).catch(error => {
            if (error.response) {
                if (error.response.status === 401) {
                    if(error.response.data.message === ResponseMessages.INVALID_TOKEN){
                        store().store.dispatch(signOut())
                    } else {
                        return error.response
                    }
                } else if (error.response.data) {
                    return error.response
                } else {
                    // Throw error if it's not a success response
                    throw new Error(`getTrackingListByAxisIdP returned a status code ${error.response.status}`)
                }
            }
        });

        if (response) {
            // If it's a success response
            if (response.status === 200) {
                return { success: true, data: response.data }
            } else {
                return { success: false, message: response.data.message }
            }
        } else {
            return { success: false, message: "Algo ocurrió mal, intentélo nuevamente" }
        }
    } catch (error) {
        console.error(error)
        return { success: false, message: "Algo ocurrió mal, intentélo nuevamente" }
    }
}
function createHeaders() {
    let headers = {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem('access_token')}`,
        "nonce": localStorage.getItem('nonce')
    }

    return headers
}


export { getTrackingListByAxisId, getTrackingListByAxisIdP }

